module.exports = class Modal {

	constructor(params) {

		Object.assign(this, params);

		this.body = document.body;
		this.closeBtns = params.closeBtns ?? this.modal.getElementsByClassName("js-close");

		this.init();
	}

	init() {

		this.modal.modalClass = this;

		if ( ! this.staticBackdrop ) {
			
			this.modal.addEventListener("click", (event) => {
	
				if (event.target == this.modal) {
					this.closeModal(event);
				}
			});
		}



		this.setOpenModalEventListeners(this.showBtns);

		for (let i = 0; i < this.closeBtns.length; i++) {
			this.closeBtns[i].addEventListener("click", this.closeModal.bind(this));
		}
	}

	setOpenModalEventListeners(elements = []) {
		return new Promise((resolve, reject) => {

			for (let i = 0; i < elements.length; i++) {
				elements[i].addEventListener("click", this.openModal.bind(this));
			}

			resolve();
		});
	}
	
	removeOpenModalEventListeners(elements) {
		return new Promise((resolve, reject) => {

			for (let i = 0; i < elements.length; i++) {
				elements[i].removeEventListener("click", this.openModal);
			}

			resolve();
		});
	}

	refreshOpenModalEventListeners(elements) {

		this.removeOpenModalEventListeners(this.showBtns)
		.then(() => {
			this.setOpenModalEventListeners(elements);
			this.showBtns = elements;
		});
	}

	openModal(event) {

		this.modal.dispatchEvent(
			new CustomEvent("modal.is.visible", {
				detail: {
					modal: this.modal,
					relatedTarget: event?.target
				}
			})
		);

		this.show();
	}

	closeModal(event) {
		
		this.modal.dispatchEvent(
			new CustomEvent("modal.is.hidden", {
				detail: {
					modal: this.modal,
					relatedTarget: event?.originalTarget
				}
			})
		);

		this.hide();
	}

	show() {

		this.modal.classList.add("active");

		if (this.body.scrollHeight > this.body.clientHeight) {
			this.body.style.paddingRight = (window.innerWidth - document.body.clientWidth) + "px";
		}

		this.body.classList.add("overflow-hidden");
	}

	hide() {

		this.modal.classList.remove("active");
		this.body.removeAttribute("style");
		this.body.classList.remove("overflow-hidden");
	}
}